<div class="title">
	<H1>Voice Macros</H1>
</div>
<div class="controls">
	<div class="search-control">
		<mat-form-field class="">
			<mat-label>Search</mat-label>
			<mat-icon matPrefix>search</mat-icon>
			<mat-icon matSuffix (click)="applyFilter()">clear</mat-icon>
			<input matInput (keyup)="applyFilter($event)" #searchInput>
		</mat-form-field>
	</div>
	<div class="create-new-button">
		<span [matTooltip]="disabled ? 'Macro limit reached':''">
			<button class="create-new-button" [disabled]="disabled" mat-flat-button (click)="createNew()">
				<mat-icon>add</mat-icon>
				Create New
			</button>
		</span>
	</div>

</div>

<div class="table-container">
	<table mat-table [dataSource]="dataSource" matSort>

		<ng-container matColumnDef="phrase">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
			<td mat-cell *matCellDef="let row"> {{ row.phrase }}</td>
		</ng-container>

		<ng-container matColumnDef="section">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Note Section</th>
			<td mat-cell *matCellDef="let row"> {{ getSectionName(row.section) }}</td>
		</ng-container>

		<ng-container matColumnDef="substitution">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Content</th>
			<td mat-cell *matCellDef="let row">{{ row.substitution }}</td>
		</ng-container>


		<ng-container matColumnDef="actions">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell class="row-controls" *matCellDef="let row" (click)="$event.stopPropagation();">

				<button mat-icon-button (click)="editMacro(row)">
					<mat-icon class="icon-color">edit_square</mat-icon>
				</button>

				<span [matTooltip]="disabled ? 'Macro limit reached':''">
					<button mat-icon-button [disabled]="disabled" (click)="duplicateMacro(row)">
						<mat-icon [class]="disabled ?'':'icon-color'">file_copy</mat-icon>
					</button>
				</span>

				<button mat-icon-button (click)="deleteMacro(row)">
					<mat-icon>delete</mat-icon>
				</button>

			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="goto(row)"></tr>

		<!-- Row shown when there is no matching data. -->
		<tr class="mat-row" *matNoDataRow>
			@if (searchInput.value) {
				<td class="mat-cell" colspan="4">No data matching the filter "{{ searchInput.value }}"</td>
			} @else {
				<td class="mat-cell" colspan="4">No macros created</td>
			}
		</tr>
	</table>

	<mat-paginator [pageSize]="10"
	               [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page">
	</mat-paginator>
</div>
